import React from 'react';
import { ClipboardList, AlertCircle, ExternalLink, CheckCircle } from 'lucide-react';
export function HowToAddCEClasses() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-919">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-920">
        {/* Page Header */}
        <div className="mb-12" data-id="element-921">
          <div className="flex items-center justify-center mb-6" data-id="element-922">
            <ClipboardList className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-923" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-924">
              HOW TO REPORT CLASSES TO ADRE
            </h1>
          </div>
        </div>

        {/* Main Instructions */}
        <div className="mb-12" data-id="element-925">
          <div className="bg-brand-purple-50 rounded-lg p-8 border-2 border-brand-purple-200 mb-8" data-id="element-926">
            <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-927">
              HOW TO REPORT CE CLASSES AND RENEW YOUR LICENSE
            </h2>
            <p className="text-base text-gray-700 font-semibold mb-2" data-id="element-928">
              *Add your current CE classes before proceeding to pay and renew
              your license.
            </p>
            <ul className="list-disc pl-5 text-base text-gray-700 space-y-1" data-id="element-929">
              <li data-id="element-930">
                School is not responsible for reporting your hours to ADRE.
              </li>
              <li data-id="element-931">Keep your certificates for 5 years.</li>
              <li data-id="element-932">Click here for directions to report CE classes to ADRE.</li>
            </ul>
          </div>

          {/* Step-by-Step Instructions */}
          <div className="space-y-6" data-id="element-933">
            {/* Step 1 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-934">
              <div className="flex items-start mb-4" data-id="element-935">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-936">
                  1
                </div>
                <div className="flex-1" data-id="element-937">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-938">
                    Click this link to log into your account at ADRE:{' '}
                    <a href="https://ptl.az.gov/dre/#/login" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline inline-flex items-center" data-id="element-939">
                      https://ptl.az.gov/dre/#/login
                      <ExternalLink className="w-4 h-4 ml-1" data-id="element-940" />
                    </a>
                  </p>
                  <p className="text-sm text-gray-600 mt-2 italic" data-id="element-941">
                    (Your license number is required to log in. If you do not
                    have it,{' '}
                    <a href="https://services.azre.gov/PdbWeb/IndividualLicense/SearchIndividualLicenses" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-942">
                      click HERE
                    </a>{' '}
                    to obtain your license number)
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-943">
              <div className="flex items-start mb-4" data-id="element-944">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-945">
                  2
                </div>
                <div className="flex-1" data-id="element-946">
                  <p className="text-base text-gray-700 leading-relaxed mb-3" data-id="element-947">
                    After logging in, under Quick Links (Personal) list, click
                    on <strong data-id="element-948">Manage My Continuing Education</strong>. On the
                    upper left side, find the box and click on{' '}
                    <strong data-id="element-949">Continuing Education</strong> and then{' '}
                    <strong data-id="element-950">Submit Courses</strong>.
                  </p>
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-951">
                    On your certificate, find and enter the course number. Use
                    the date on your certificate for Date Started and Date
                    Finished.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-952">
              <div className="flex items-start mb-4" data-id="element-953">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-954">
                  3
                </div>
                <div className="flex-1" data-id="element-955">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-956">
                    Once your courses are all succesfully recorded, click the
                    blue <strong data-id="element-957">Return Home</strong> button. Under Quick Links
                    (Personal) list, find and click{' '}
                    <strong data-id="element-958">Renew My License</strong>. Follow all the prompts,
                    answer YES/NO questionanaire and then pay your license
                    renewal fee.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-959">
              <div className="flex items-start mb-4" data-id="element-960">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-961">
                  4
                </div>
                <div className="flex-1" data-id="element-962">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-963">
                    After paying for your new license, print a copy of the
                    confirmation for your records (you may need to provide this
                    confirmation to your broker). Once you renew your license,
                    you and/or your broker may print your license online at the
                    ADRE website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="space-y-6 mb-12" data-id="element-964">
          {/* Important Warning */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-965">
            <div className="flex items-start" data-id="element-966">
              <AlertCircle className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-967" />
              <p className="text-base text-gray-800" data-id="element-968">
                <strong data-id="element-969">
                  **We suggest that you add your classes directly to ADRE's
                  website.
                </strong>{' '}
                If you send copies of your certificates to ADRE, they can charge
                you an additional $50.00
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}